import Flickity from "flickity";
require('flickity-fade');

export default function () {

  const clientsCarousels = document.querySelectorAll('.js-clients-carousel-block');

  if(clientsCarousels) {
    clientsCarousels.forEach(function (elem, index) {
      if (elem) {
        // Define carousel options
        let carouselOptions = {
          cellAlign: 'left',
          prevNextButtons: false,
          autoPlay: 4000,
          fade: true
        };

        // Check if there's only one slide
        if (elem.children.length > 1) {
          carouselOptions.pageDots = true;
        } else {
          carouselOptions.pageDots = false;
        }

        new Flickity(elem, carouselOptions);
      }
    });
  }
}
